import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../constants/authRoutes';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

api.interceptors.request.use(
    (config) => {
        const authData = JSON.parse(sessionStorage.getItem("auth") || "{}");
        const accessToken = authData.accessToken;
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        const errorMessage = error.response?.data?.message || 'Error de servidor';
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
        });
        return Promise.reject(error);
    }
);

export default api;
